import { Button, Card, Form, Space, Table } from "antd";
import React, { useEffect, useState } from "react";
import { API } from "../../config/api";
import { POST } from "../../utils/apicalls";
import moment from "moment";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import jsPDF from "jspdf";
import logo from "../../assests/papalogo.png";

function Salary_Details() {
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const [data, setData] = useState<any>([]);
  const [meta, setMeta] = useState<any>({});
  const user: any = useSelector((state: RootState) => state?.user); // Access user state
  useEffect(() => {
    filterSalary();
  }, []);
  const filterSalary = async () => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        employeeId: user.id,
      };
      const url = API.SEARCH_SALARY_DETAILS;
      const response: any = await POST(url, obj);
      setData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const formatDate = (dateString: string) => {
    if (!dateString) return "N/A"; // Handle empty or null dates
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "Invalid Date"; // Handle invalid dates
    return date.toLocaleDateString("en-GB"); // Format as DD/MM/YYYY
  };
  const columns = [
    {
      dataIndex: "type",
      title: "Type",
      render: (type: any) => {
        let color = "";
        switch (type?.toLowerCase()) {
          case "approved":
            color = "green";
            break;
          case "rejected":
            color = "red";
            break;
          default:
            color = "black"; // Default color for other statuses
        }
        return <span style={{ color }}>{type}</span>;
      },
    },

    {
      dataIndex: "date",
      title: "date",
      render: (date: any) => (date ? moment(date).format("DD/MM/YYYY") : "-"),
    },
    // {
    //   dataIndex: "employeeId",
    //   title: "Employee",
    //   render: (_: any, value: any) => {
    //     const employeeName = value?.empid?.fullName || "N/A";
    //     return <span>{employeeName}</span>;
    //   },
    // },

    {
      dataIndex: "IN_Amount",
      title: "IN_Amount",
    },
    {
      dataIndex: "OUT_Amount",
      title: "OUT_Amount ",
    },
    {
      dataIndex: "TotalAmount",
      title: "TotalAmount ",
    },
    {
      dataIndex: "category",
      title: "category ",
    },
    {
      dataIndex: "method",
      title: "method ",
    },
    {
      title: "Action",
      key: "id",
      render: (_: any, record: any) => (
        <Space size="middle">
          <Button
            type="primary"
            onClick={() => {
              const doc = new jsPDF();

              const pageWidth = doc.internal.pageSize.getWidth(); // Page width
              const centerX = pageWidth / 2; // Center X-coordinate
              const labelOffset = 10; // Offset for labels to the left of   center
              const valueOffset = 10; // Offset for values to the right of center

              // Add logo at the top center
              const imgWidth = 50;
              const imgHeight = 50;
              doc.addImage(
                logo,
                "PNG",
                centerX - imgWidth / 2,
                10,
                imgWidth,
                imgHeight
              ); // Center logo

              // Add title
              doc.setFontSize(16);
              doc.text("Salary Slip", centerX, 70, { align: "center" });

              doc.setFontSize(12);
              doc.text("PAPA DIGITAL SOLUTION", centerX, 80, {
                align: "center",
              });

              // Employee Details
              doc.setFontSize(10);
              let y = 100; // Start Y-position
              const lineHeight = 10; // Line height for spacing

              doc.text("Employee Name:", centerX - labelOffset, y, {
                align: "right",
              });
              doc.text(
                `${record.empid?.fullName || "N/A"}`,
                centerX + valueOffset,
                y,
                { align: "left" }
              );
              y += lineHeight;

              doc.text("Designation:", centerX - labelOffset, y, {
                align: "right",
              });
              doc.text(
                `${record.empid?.type || "N/A"}`,
                centerX + valueOffset,
                y,
                { align: "left" }
              );
              y += lineHeight;

              doc.text("Department:", centerX - labelOffset, y, {
                align: "right",
              });
              doc.text(
                `${record.empid?.department || "N/A"}`,
                centerX + valueOffset,
                y,
                { align: "left" }
              );
              y += lineHeight;

              doc.text("Date of Joining:", centerX - labelOffset, y, {
                align: "right",
              });
              doc.text(
                `${formatDate(record.empid?.hireDate)}`,
                centerX + valueOffset,
                y,
                { align: "left" }
              );
              y += 2 * lineHeight; // Extra spacing before totals

              // Totals
              doc.setFontSize(12);
              doc.text("In Amount:", centerX - labelOffset, y, {
                align: "right",
              });
              doc.text(`${record.IN_Amount || 0}`, centerX + valueOffset, y, {
                align: "left",
              });
              y += lineHeight;

              doc.text("Out Amount:", centerX - labelOffset, y, {
                align: "right",
              });
              doc.text(`${record.OUT_Amount || 0}`, centerX + valueOffset, y, {
                align: "left",
              });
              y += lineHeight;

              doc.text("Total Amount:", centerX - labelOffset, y, {
                align: "right",
              });
              doc.text(`${record.TotalAmount || 0}`, centerX + valueOffset, y, {
                align: "left",
              });
              y += 2 * lineHeight; // Extra spacing before footer

              // Footer
              doc.text("Employer Signature", centerX - labelOffset, y, {
                align: "right",
              });
              doc.text("Employee Signature", centerX + valueOffset, y, {
                align: "left",
              });

              // Save the PDF
              doc.save(`payslip-${record.id}.pdf`);
            }}
          >
            Download Payslip
          </Button>
        </Space>
      ),
    },
  ];
  return (
    <div>
      <Card>
        <Table columns={columns} dataSource={data} />
      </Card>
    </div>
  );
}

export default Salary_Details;
